import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import DashboardFilter from "../dashboardFilter/index";
import DeviceSalesViews from "../../views/deviceSales/index";
import CustomLandingBody from "../../components/customLandingBody";
import Spinner from "../../components/presentationals/Spinner";

import {
  triggerFetchAllEndPoints,
  triggerFetchDistributionTable,
  triggerFetchSalesTable,
  triggerFetchSalesCsv,
  triggerRDSAPI,
  triggerStockAPI,
  triggerStockCsvAPI,
  triggerFetchTimeStamp,
  unsetRun,
} from "../../redux/actions";
import {
  triggerShowHeader,
  triggerShowSidebar,
  unsetPayoutDashboard,
} from "../../redux/actions/action";
import { hideAlert } from "../../redux/actions/homeAction";
import { triggerIsDashboardAccessible } from "../../redux/actions/dashboardsAccessibility";
import { getPartnerRoleID, validatePartnerRoleType } from "../../utils/common";
import Alert from "../../components/alert";
// import { Cookies } from 'react-cookie';
class Home extends React.Component {
  constructor() {
    super();
    this.state = {
      showAlert: null,
      dashboardName: "Device Sales",
    };
  }

  callTimeStamp(props) {
    const moduleName =
      props.getAllAPI && props.getAllAPI.data && props.getAllAPI.data.content
        ? props.getAllAPI.data.content.filter(
            (item) => item.moduleName.toLowerCase() === "device sales"
          )[0].moduleName
        : null;

    let timeStampObj = {
      headers: {
        "Content-Type": "application/json",
      },
      params: {
        moduleName: moduleName,
        partnerRole: getPartnerRoleID(
          props.filterValue.selectedPartnerRoleName
        ),
      },
    };
    this.props.triggerFetchTimeStamp(timeStampObj, moduleName);
  }

  componentDidMount() {
    //upon component load, set show sidebar to false always
    // this.props.triggerShowSidebar(false);
    this.props.unsetPayoutDashboard();
    this.props.unsetRun();

    //check if isTestingActive is true, then send api call for triggerIsDashboardAccessible
    let isTestingActive = this.props.tilesData?.data?.content?.filter(
      (obj) => obj.moduleName === this.state.dashboardName
    )[0].isTestingActive;

    //if it is true, then check if this loggedin user has access to this dashboard
    if (isTestingActive) {
      //to check if the response for this dashboard api call is already cached in redux
      let isExistingDashboard = this.props.dashboardAccessibility?.data?.filter(
        (currentDashboard) =>
          currentDashboard.dashboard === this.state.dashboardName
      );

      //if dashboard accessibility is already cached and accessEnabled is false, means directly show alert without sending api call again
      if (
        isExistingDashboard.length > 0 &&
        !isExistingDashboard[0]?.isDashboardAccessible?.accessEnabled
      ) {
        // load dashboardcard home component and show alert
        return this.setState({
          showAlert: true,
        });
      }

      // if dashboard accessibility is cached and accessEnabled is true, do not send api call, do not show alert BUT SHOW DASHBOARD NORMALLY
      else if (
        isExistingDashboard.length > 0 &&
        isExistingDashboard[0]?.isDashboardAccessible?.accessEnabled
      ) {
        this.setState({
          showAlert: false,
        });

        this.props.triggerShowHeader(true);
        if (
          this.props.getAllAPI &&
          this.props.getAllAPI.data &&
          this.props.getAllAPI.data.content
        ) {
          this.callTimeStamp(this.props);
        }
      }

      //if dashboard accessibility is not cached already then send api call for this dashboard
      else {
        const data = {
          baseParameter: {
            name: this.state.dashboardName,
            userType: this.props.filterValue.site,
          },
          domainId:
            this.props.filterValue.orgId !== ""
              ? this.props.filterValue.orgId
              : this.props.filterValue?.agentId,
        };

        const obj = {
          headers: {
            "Content-Type": "application/json",
            url: "get-dashboard-user-role-mapping",
          },
          params: data,
          extraData: "get-dashboard-user-role-mapping",
        };

        return this.props.triggerIsDashboardAccessible(obj, (res) => {
          //if the response shows access enabled as false, go to home page and show alert
          if (!res.content.accessEnabled) {
            return this.setState({
              showAlert: true,
            });
          } else {
            this.setState({
              showAlert: false,
            });

            this.props.triggerShowHeader(true);
            if (
              this.props.getAllAPI &&
              this.props.getAllAPI.data &&
              this.props.getAllAPI.data.content
            ) {
              this.callTimeStamp(this.props);
            }
          }
        });
      }
    }

    //if isTestingActive is false, it is open for all users
    else {
      this.setState({
        showAlert: false,
      });

      this.props.triggerShowHeader(true);
      if (
        this.props.getAllAPI &&
        this.props.getAllAPI.data &&
        this.props.getAllAPI.data.content
      ) {
        this.callTimeStamp(this.props);
      }
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.props.getAllAPI &&
      this.props.getAllAPI.data &&
      !this.props.getAllAPI.data.content &&
      nextProps.getAllAPI.data.content
    ) {
      this.callTimeStamp(nextProps);
    }
  }

  render() {
    return this.state.showAlert === null ? (
      <Spinner />
    ) : this.state.showAlert ? (
      <CustomLandingBody
        showAlert={this.state.showAlert}
        dashboardName={this.state.dashboardName}
      />
    ) : (
      <div className="container-fluid">
        {this.props.partnerRoleType &&
        validatePartnerRoleType(this.props.partnerRoleType).showFilters ? (
          <DashboardFilter dashboard={this.state.dashboardName} />
        ) : null}
        <h2
          className="pagetitle wow fadeInUp"
          data-wow-delay=".5s"
          data-wow-duration="0.7s"
        >
          Device Sales
        </h2>
        <Alert
          showAlert={this.props.showAlert}
          hideAlert={this.props.hideAlert}
        />
        {this.props.shouldRun ? (
          <DeviceSalesViews
            startDate={this.props.headerSelectedDateFrom}
            endDate={this.props.headerSelectedDateTo}
            valueUnit={this.props.headerUnit}
            filterValue={this.props.filterValue}
            triggerFetchAllEndPoints={this.props.triggerFetchAllEndPoints}
            getAllAPI={this.props.getAllAPI}
            triggerFetchDistributionTable={
              this.props.triggerFetchDistributionTable
            }
            distributionObj={this.props.distributionObj}
            triggerFetchSalesTable={this.props.triggerFetchSalesTable}
            triggerFetchSalesCsv={this.props.triggerFetchSalesCsv}
            salesObj={this.props.salesObj}
            salesCsvObj={this.props.salesCsvObj}
            triggerRDSAPI={this.props.triggerRDSAPI}
            rdsObj={this.props.rdsObj}
            triggerStockAPI={this.props.triggerStockAPI}
            triggerStockCsvAPI={this.props.triggerStockCsvAPI}
            stockObj={this.props.stockObj}
            stockCSVObj={this.props.stockCSVObj}
            timestamp={this.props.timestamp && this.props.timestamp.data}
          />
        ) : (
          <div
            className="whitebox wow fadeInUp text-center disclaimer p-4 rounded"
            data-wow-delay=".6s"
            data-wow-duration="0.7s"
          >
            <ul>
              <li>{window.CLICK_RUN_1}</li>
              {this.props.partnerRoleType &&
              validatePartnerRoleType(this.props.partnerRoleType)
                .showFilters ? (
                <li>{window.CLICK_RUN_2}</li>
              ) : null}
            </ul>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  let {
    headerSelectedDateFrom,
    headerSelectedDateTo,
    headerUnit,
    filterValue,
    filterList,
    getAllAPI,
    distributionObj,
    salesObj,
    salesCsvObj,
    rdsObj,
    stockObj,
    stockCSVObj,
    partnerRoleType,
    timestamp,
    tilesData,
    showAlert,
    shouldRun,
  } = state.homeReducer;

  let { dashboardAccessibility } = state.dashboardAccessibilityReducer;

  return {
    headerSelectedDateFrom,
    headerSelectedDateTo,
    headerUnit,
    filterValue,
    filterList,
    getAllAPI,
    distributionObj,
    salesObj,
    salesCsvObj,
    rdsObj,
    stockObj,
    stockCSVObj,
    partnerRoleType,
    timestamp,
    tilesData,
    showAlert,
    dashboardAccessibility,
    shouldRun,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      triggerFetchAllEndPoints,
      triggerFetchDistributionTable,
      triggerFetchSalesTable,
      triggerFetchSalesCsv,
      triggerRDSAPI,
      triggerStockAPI,
      triggerStockCsvAPI,
      triggerShowHeader,
      unsetPayoutDashboard,
      triggerShowSidebar,
      triggerFetchTimeStamp,
      triggerIsDashboardAccessible,
      hideAlert,
      unsetRun,
    },
    dispatch
  );
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Home));
